export default __webpack_public_path__ + "static/media/miembrosume_registro_verde.73f86769.png";